import { Cookies } from 'react-cookie';
const cookies = new Cookies();

export const setCookie = (name, value, options) => {
    cookies.set(name, value, options);
};

export const removeCookie = (name, options) => {
    cookies.remove(name, options);
};

export const getCookie = (name, options) => {
    return cookies.get(name, options);
};

export const getAllCookies = options => {
    return cookies.get(options);
};



// WEBPACK FOOTER //
// ./src/services/helper/cookie-helper.js